import { ReactNode } from 'react';
import styles from './link.module.scss';

interface IProps {
    children: ReactNode,
    href?: string,
    target?: string,
}

const Link: React.FC<IProps> = (props) => {
    return (<a href={props.href || '#'} target={props.target} className={styles.link}>{props.children}</a>);
}

export default Link;